import mapFunction from './mapResources';

export default mapFunction('tablets', {
    isFetching: false,
    items: [] 
});